import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Reveal from '../components/Reveal';
import SectionHeading from '../components/SectionHeading';

const {FiMinus, FiPlus, FiSmile} = FiIcons;

const pains = [
  'Klebrige Böden',
  'Aggressive Betrunkene',
  'Schlechter Sound',
  'Liebloses Zeltfest-Ambiente',
  'Schlechtes Fast-Food'
];

const gains = [
  'Ein "Safe Space" für gute Laune.',
  'Ein Festival, das optisch was hermacht (Instagram-tauglich).',
  'Leckere Drinks (Aperol, Craft Beer, gute Weine), saubere sanitäre Anlagen und eine mitreißende, bunte Festival-Produktion.'
];

function AudienceSection() {
  return (
    <section className="section audience-section" id="zielgruppe">
      <div className="section-inner">
        <SectionHeading eyebrow="03 — Für wen wir feiern">
          Die stilvollen Feierbiester (30-55 Jahre)
        </SectionHeading>
        <Reveal className="persona-intro">
          <span className="persona-icon"><SafeIcon icon={FiSmile} /></span>
          <p>Sie lieben die Ausgelassenheit des Schlagers, bunte Outfits und das Mitsingen, haben aber keine Lust mehr auf schmutzige Dixi-Klos und lauwarmes Bier aus Plastikkanistern.</p>
        </Reveal>
        <div className="persona-columns">
          <Reveal className="persona-card pain-card">
            <div className="persona-card-title">
              <span className="list-symbol"><SafeIcon icon={FiMinus} /></span>
              <h3>Was sie vermeiden wollen</h3>
            </div>
            <ul>{pains.map((item) => <li key={item}>{item}</li>)}</ul>
          </Reveal>
          <Reveal className="persona-card gain-card" delay={0.12}>
            <div className="persona-card-title">
              <span className="list-symbol"><SafeIcon icon={FiPlus} /></span>
              <h3>Was sie bei uns bekommen</h3>
            </div>
            <ul>{gains.map((item) => <li key={item}>{item}</li>)}</ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

export default AudienceSection;